import React, { useState } from "react";
import { Plus, Minus } from "lucide-react";

export const AccordionItem = ({ title, children, defaultOpen = false }) => {
  const [open, setOpen] = useState(defaultOpen);
  return (
    <div className="border-b border-ink/15">
      <button
        onClick={() => setOpen((o) => !o)}
        className="flex w-full items-center justify-between py-5 text-left"
        aria-expanded={open}
        data-testid={`accordion-${title?.toLowerCase().replace(/\s+/g, "-")}`}
      >
        <span className="font-mono text-xs uppercase tracking-[0.2em]">
          {title}
        </span>
        {open ? <Minus size={18} /> : <Plus size={18} />}
      </button>
      {open && (
        <div className="pb-6 text-sm leading-relaxed text-ink/70 animate-fade-in">
          {children}
        </div>
      )}
    </div>
  );
};

const Accordion = ({ children }) => <div className="w-full">{children}</div>;

export default Accordion;
